import {PayrollSchedule} from '../../models';
import {API} from '../types';

type Params = {
  scheduledAt: string;
};

interface Response {
  schedule: PayrollSchedule;
}

export function createPayrollScheduleAPI(params: Params): API<Response> {
  return {
    getData: async client => {
      const {data} = await client({
        url: '/payroll-schedules',
        method: 'POST',
        data: params,
      });
      return {data: {schedule: data}};
    },
    getMockData: () => {
      return {
        schedule: {
          id: 1,
          scheduledAt: '',
        },
      };
    },
  };
}
